import React, { useMemo } from 'react';
import classnames from 'classnames';
import { createUseStyles, Section as SectionHoi } from '@Sage/hoi-poi-ui';
import PropTypes from 'prop-types';

import styles from './styles';
const useStyles = createUseStyles(styles, 'Section');

function Section({ className, label, expandable, children, ...props }) {
    const classes = useStyles();
    const headerClasses = useMemo(
        () => ({
            header: classes.header,
        }),
        [classes.header],
    );
    return (
        <SectionHoi
            className={classnames(classes.root, className)}
            title={label}
            isExpandable={expandable}
            classes={headerClasses}
        >
            {children}
        </SectionHoi>
    );
}

Section.propTypes = {
    label: PropTypes.string,
    expandable: PropTypes.bool,
    uiGrid: PropTypes.string,
};

export default React.memo(Section);
